import { CSS } from '@grupoboticario/flora-react'

const BORDER_RADIUS = '4px'
const TRANSITION_EASE = '0.2s ease'

export const containerStyle = {
  marginTop: '$2',
  flexShrink: 0
}

export const previewBoxStyle = {
  position: 'relative',
  backgroundColor: '$light-light',
  borderRadius: BORDER_RADIUS
}

export const previewLabelStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative',
  '&:hover .hover-overlay': {
    opacity: 1
  }
}

export const hoverOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  borderRadius: BORDER_RADIUS,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: 0,
  transition: `opacity ${TRANSITION_EASE}`
}

export const uploadAreaBoxStyle = {
  position: 'relative'
}

export const uploadLabelStyle = {
  position: 'absolute',
  top: '$2',
  left: '$3',
  fontSize: '$body-small',
  color: '$medium-light-1',
  backgroundColor: '$light-light',
  padding: '$2 $1',
  zIndex: 1,
  fontWeight: '$regular'
}

export const uploadFlexStyle = {
  cursor: 'pointer',
  borderRadius: BORDER_RADIUS,
  transition: `all ${TRANSITION_EASE}`,
  pointerEvents: 'auto',
  '&:hover': {
    borderColor: '$brand-standard'
  }
}

export const uploadTextStyle = {
  fontSize: '$caption',
  textAlign: 'center'
}

export const infoTextStyle = {
  textAlign: 'right',
  paddingRight: '$4',
  fontSize: '$caption',
  color: '$medium-medium'
}

export const requiredAsteriskStyle = {
  color: '$error-standard'
}

export const selectFileLinkStyle = {
  color: '$brand-standard',
  textDecoration: 'underline',
  fontWeight: '$medium'
}

export const getPreviewImageStyle = (dimensions: { WIDTH: string | number; HEIGHT: string | number }) => ({
  width: dimensions.WIDTH,
  height: dimensions.HEIGHT,
  objectFit: 'cover',
  borderRadius: BORDER_RADIUS
})

export const overlayTextCss: CSS = {
  color: '$nonInteractiveAltPredominant'
}

export const getHoverOverlayCss = (width: string | number, height: string | number): CSS => ({
  ...hoverOverlayStyle,
  width,
  height
})

export const getUploadFlexCss = (isDragging: boolean, width: string | number, height: string | number): CSS => ({
  ...uploadFlexStyle,
  border: isDragging ? '2px dashed $brand-standard' : '1px dashed $medium-light-3',
  backgroundColor: isDragging ? '$brand-light' : '$light-light',
  width,
  height
})
